import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { FILTER } from 'Component/Header/Header.config';

import { changeNavigationState, goToPreviousNavigationState } from 'Store/Navigation/Navigation.action';
import { BOTTOM_NAVIGATION_TYPE, TOP_NAVIGATION_TYPE } from 'Store/Navigation/Navigation.reducer';
import { hideActiveOverlay } from 'Store/Overlay/Overlay.action';
import { CATEGORY_FILTER_OVERLAY_ID } from 'Component/CategoryFilterOverlay/CategoryFilterOverlay.config';

/** @namespace Component/CategoryFilterOverlay/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    isInfoLoading: state.ProductListInfoReducer.isLoading,
    isProductsLoading: state.ProductListReducer.isLoading,
    totalPages: state.ProductListReducer.totalPages,
    activeOverlay: state.OverlayReducer.activeOverlay,
    navigationState: state.NavigationReducer[BOTTOM_NAVIGATION_TYPE].navigationState,
    device: state.ConfigReducer.device,
});

/** @namespace Component/CategoryFilterOverlay/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    hideActiveOverlay: () => dispatch(hideActiveOverlay()),
    goToPreviousHeaderState: () => dispatch(goToPreviousNavigationState(TOP_NAVIGATION_TYPE)),
    goToPreviousNavigationState: () => dispatch(goToPreviousNavigationState(BOTTOM_NAVIGATION_TYPE)),
    changeHeaderState: (state) => dispatch(changeNavigationState(TOP_NAVIGATION_TYPE, state)),
    changeNavigationState: (state) => dispatch(changeNavigationState(BOTTOM_NAVIGATION_TYPE, state))
});

import { CategoryFilterOverlayContainer as SourceCategoryFilterOverlayContainer } from 'SourceComponent/CategoryFilterOverlay/CategoryFilterOverlay.container';

export class CategoryFilterOverlayContainer extends SourceCategoryFilterOverlayContainer {
    containerFunctions = {
        onSeeResultsClick: this.onSeeResultsClick.bind(this),
        toggleCustomFilter: this.toggleCustomFilter.bind(this),
        getFilterUrl: this.getCustomFilterUrl.bind(this),
        onVisible: this.onVisible.bind(this),
        onHide: this.onHide.bind(this)
    };

    componentDidUpdate() {
        const {
            activeOverlay,
            navigationState: {
                name
            },
            device,
        } = this.props;

        if (activeOverlay === CATEGORY_FILTER_OVERLAY_ID && 
            name !== FILTER && device.isMobile) {
                this.onVisible();
        }
    }
    
    containerProps = () => {
        const {
            availableFilters,
            customFiltersValues,
            isCategoryAnchor,
            isInfoLoading,
            isMatchingInfoFilter,
            isProductsLoading,
            totalPages,
            activeStatus,
            isMobile
        } = this.props;

        return {
            availableFilters,
            isCategoryAnchor,
            isInfoLoading,
            isProductsLoading,
            isMatchingInfoFilter,
            totalPages,
            customFiltersValues,
            areFiltersEmpty: this.getAreFiltersEmpty(),
            isContentFiltered: this.isContentFiltered(),
            activeStatus,
            isMobile
        };
    };

    onSeeResultsClick() {
        const {
            hideActiveOverlay,
            goToPreviousHeaderState,
            goToPreviousNavigationState
        } = this.props;

        hideActiveOverlay();
        goToPreviousHeaderState();
        goToPreviousNavigationState();
    }

    onVisible() {
        const {
            hideActiveOverlay,
            changeHeaderState,
            changeNavigationState,
            goToPreviousNavigationState,
            location: { pathname, search }
        } = this.props;

        changeHeaderState({
            name: FILTER,
            title: __('Filters'),
            onCloseClick: () => {
                hideActiveOverlay();
                goToPreviousNavigationState();
            }
        });

        changeNavigationState({
            name: FILTER,
            isHidden: true
        });

        window.addEventListener('popstate', this.historyBackHook);

        history.pushState(
            { overlayOpen: true },
            '',
            pathname + search
        );
    }
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(CategoryFilterOverlayContainer)
);
